module.exports = __webpack_public_path__ + "static/media/DSC00275.df844826.jpg";